<section class="bg-half-260 d-table w-100" style="background: linear-gradient( rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2) ), url('assets/images/new-bg-opsi-2.jpeg') center center;">
  <div class="container">
    <div class="row mt-5 mt-md-4">
      <div class="col-12">
        <div class="title-heading">
          <h4 class="display-4 mb-4 fw-bold text-white title-dark"><span class="color-brand">Remittance</span> <br>
            <span>at your fingertips</span>
          </h4>
          <p class="para-desc text-white">Simple, reliable, and fast transfer</p>
          <div class="mt-4 pt-2">
            <!-- <button type="button" (click)="routeHelper.navigated('register')" class="btn btn-brand">Register
              Now</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="sections">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title mb-4 pb-2">
          <p>&nbsp;</p>
          <h4 class="title mb-4">About Us</h4>
          <p class="text-muted  mb-0 mx-auto">
            Prima Express Limited was incorporated in March 2002, in Hong Kong . Since our humble beginnings in Hong
            Kong in 2002 ,as a remittance company, we have since been appointed as delivery Agents for Local Hong Kong
            remit companies and from other countries around the region such as Singapore, Malaysa , Brunei and
            Bangladesh. With our vast network of established Agents, we are able to transfer and deliver funds
            effectively for your clients, friends and business associates in a reliable, secure and efficient way,
            either to your designated bank account or door to door delivery where possible
          </p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-12 mt-5">
        <div class="features text-center">
          <div class="image position-relative d-inline-block">
            <i class='bx bxs-timer h2 color-brand'></i>
          </div>
          <div class="content mt-4">
            <h5>Mission</h5>
            <p class="text-muted mb-0">
              To become a market leader and innovator in the field of payments, fund transfers and remittances in
              Southeast Asia.
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-6 col-12 mt-5">
        <div class="features text-center">
          <div class="image position-relative d-inline-block">
            <i class='bx bxs-check-shield h2 color-brand'></i>
          </div>
          <div class="content mt-4">
            <h5>Vision</h5>
            <p class="text-muted mb-0">
              Keeping the customer at the heart of our decision making process, we strive to continually come up with
              new ways to make life easier for our consumers around the world.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- <section class="section overflow-hidden" style="padding-top: 0 !important; padding-bottom: 50px !important;">
  <div class="container mt-100">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-5">
        <div class="app-feature-shape-left position-relative">
          <div class="text-center text-md-start">
            <img src="assets/images/app/classic04.png" class="img-fluid" alt="">
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-7 mt-5 mt-sm-0">
        <div class="section-title">
          <h1 class="title mb-3">Beautiful, Simple & <br> Easy to Use</h1>
          <p class="para-desc text-muted">Launch your campaign and benefit from our expertise on designing and managing
            conversion centered bootstrap v5 html page.</p>
          <ul class="list-unstyled text-muted">
            <li class="mb-1"><span class="text-primary color-brand h5 me-2"><i
                  class='bx bxs-check-circle'></i></span>Digital Marketing Solutions for Tomorrow</li>
            <li class="mb-1"><span class="text-primary color-brand h5 me-2"><i
                  class='bx bxs-check-circle'></i></span>Our Talented & Experienced Marketing Agency</li>
            <li class="mb-1"><span class="text-primary color-brand h5 me-2"><i
                  class='bx bxs-check-circle'></i></span>Create your own skin to match your brand</li>
          </ul>
          <div class="mt-4">
            <button type="button" (click)="routeHelper.navigated('register')" class="btn btn-brand"><i
                class='bx bx-chevron-right'></i> Register Now</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->

<section class="section" style="margin-top: 50px !important;">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="section-title text-center mb-4 pb-2">
          <h4 class="title mb-4">Our Services</h4>
          <p class="text-muted mx-auto mb-0">
            With strong partnerships around the globe, we are able to offer a number of services to our customers,
            regardless of their country of residence. These services pave the way for our customers to better facilitate
            the movement of their money as well as the purchase of goods and services internationally. Endeavoring to
            increase the number of services we provide to our customers, we constaly seek new international business
            partners to establish a strong global network of payments.
          </p>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-4 mt-4 pt-2">
        <div class="card features fea-primary rounded p-4 bg-light position-relative overflow-hidden border-0">
          <div class="align-items-center">
            <span class="h2 mb-0 icon2 color-brand float-md-end">
              <i class='bx bx-money'></i>
            </span>
            <h5 class="mb-0 mt-md-2">Cash Pick Up</h5>
          </div>
          <div class="card-body p-0 content mt-3" style="height: 100px;">
            <p class="para text-muted mb-0">
              Cash Collection available from thousands of collection points worldwide
            </p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 mt-4 pt-2">
        <div class="card features fea-primary rounded p-4 bg-light position-relative overflow-hidden border-0">
          <div class="align-items-center">
            <span class="h2 mb-0 icon2 color-brand float-md-end">
              <i class='bx bxs-bank'></i>
            </span>
            <h5 class="mb-0 mt-md-2">Direct to Account</h5>
          </div>
          <div class="card-body p-0 content mt-3" style="height: 100px;">
            <p class="para text-muted mb-0">
              Deposit directly into a designated bank account from hundreds of different banks
            </p>
            <p>&nbsp;&nbsp;</p>
          </div>
        </div>
      </div>

      <div class="col-lg-4 mt-4 pt-2">
        <div class="card features fea-primary rounded p-4 bg-light position-relative overflow-hidden border-0">
          <div class="align-items-center">
            <span class="h2 mb-0 icon2 color-brand float-md-end">
              <i class='bx bx-globe'></i>
            </span>
            <h5 class="mb-0 mt-md-2">Instantaneous Transfers</h5>
          </div>
          <div class="card-body p-0 content mt-3" style="height: 100px;">
            <p class="para text-muted mb-0">
              Beneficiaries recieve payment within seconds of remittance
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="section mb-4" style="padding: 0px !important;">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="section-title text-center pb-2">
          <h4 class="title mb-4">Partners</h4>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 mt-4 pt-2">
        <div class="card rounded p-4 position-relative overflow-hidden border-0">
          <img src="assets/logo/money-gram-new.png" alt="">
        </div>
      </div>
      <div class="col-lg-3 mt-4 pt-2">
        <div class="card rounded p-4 position-relative overflow-hidden border-0">
          <img src="assets/logo/atm-bersama-new.png" alt="">
        </div>
      </div>
      <div class="col-lg-3 mt-4 pt-2">
        <div class="card rounded p-4 position-relative overflow-hidden border-0">
          <img src="assets/logo/land-bank-new.png" alt="">
        </div>
      </div>
      <div class="col-lg-3 mt-4 pt-2">
        <div class="card rounded p-4 position-relative overflow-hidden border-0">
          <img src="assets/logo/agrani-bank-new.png" alt="">
        </div>
      </div>
      <div class="col-lg-3 mt-4 pt-2">
        <div class="card rounded p-4 position-relative overflow-hidden border-0">
          <img src="assets/logo/kh-remit-new.png" alt="">
        </div>
      </div>
      <div class="col-lg-3 mt-4 pt-2">
        <div class="card rounded p-4 position-relative overflow-hidden border-0">
          <img src="assets/logo/maji-remittance-new.png" alt="">
        </div>
      </div>
      <div class="col-lg-3 mt-4 pt-2">
        <div class="card rounded p-4 position-relative overflow-hidden border-0">
          <img src="assets/logo/TML-remittance-new.png" alt="">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- <section class="section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="section-title text-center mb-4 pb-2">
          <h4 class="title mb-4">Quick Guide to Transfer</h4>
        </div>
      </div>
    </div>
    <div class="card rounded shadow border-0 bg-light overflow-hidden" style="padding-bottom: 50px !important;">
      <div class="row justify-content-center">
        <div class="tiny-single-item">
          <div class="tiny-slide client-testi">
            <div class="row g-0">
              <div class="col-lg-6">
                <img src="assets/images/event/about.jpg" class="img-fluid" alt="">
              </div>
              <div class="col-lg-6">
                <div class="card-body section-title p-md-5">
                  <h4 class="title mb-4">Business Startup Conference</h4>
                  <p class="text-muted para-desc mb-0">Start working with Landrick that can provide everything you need
                    to generate awareness, drive traffic, connect. Launch your campaign and benefit from our expertise
                    on designing and managing conversion centered bootstrap v5 html page managing conversion centered
                    bootstrap v5 html page.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="tiny-slide client-testi">
            <div class="row g-0">
              <div class="col-lg-6">
                <img src="assets/images/event/about.jpg" class="img-fluid" alt="">
              </div>
              <div class="col-lg-6">
                <div class="card-body section-title p-md-5">
                  <h4 class="title mb-4">Business Startup 111 aaa</h4>
                  <p class="text-muted para-desc mb-0">Start working with Landrick that can provide everything you need
                    to generate awareness, drive traffic, connect. Launch your campaign and benefit from our expertise
                    on designing and managing conversion centered bootstrap v5 html page managing conversion centered
                    bootstrap v5 html page.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->

<section class="section" style="padding-top: 0;">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 text-center">
        <div class="section-title mb-4">
          <h4 class="title mb-4">Branch Locations</h4>
        </div>
      </div>
    </div>

    <div class="row justify-content-center mt-4">
      <div class="col-lg-12 col-12">
        <div class="card rounded bg-light border-0 m-2">
          <div class="component-wrapper rounded shadow">
            <div class="map">
              <iframe src="https://www.google.com/maps/d/u/3/embed?mid=1s4_i50s-p6YckNEVLdaTJJWj9K9ArRY&ehbc=2E312F" style="border:0" class="rounded"></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
